import React, {useState} from 'react';
import Icon from '../Icons/Icon';
import { useToasts } from '../Toasts';
import { classNames } from '../../Services/helpers';

const CopyableValue = ({title, value, copiedTitle, className, fontMono, trackingWide, flush, multiLine}) => {
    const [copied, setCopied] = useState(false);
    const {showSuccess} = useToasts();

    const copy = () => {
        navigator.clipboard.writeText(value);
        setCopied(true);
        showSuccess(copiedTitle ? copiedTitle : (title ? `${title} copied to clipboard` : 'Copied to clipboard'));
        setTimeout(() => setCopied(false), 2000);
    }

    return <div className={className ?? null}>
        {title && <div className="font-bold mb-2">{title}</div>}
        <div className={classNames(
            'flex space-between rounded-lg transition-colors cursor-pointer',
            flush !== true && 'p-2 surface-outline text-sm',
            flush !== true && (copied ? 'surface-4' : 'surface-2'),
            (flush && copied) && 'text-brand',
        )} onClick={copy}>
            <span className={classNames(
                'block grow',
                multiLine ? 'whitespace-pre-wrap' : 'break-all',
                fontMono && 'font-mono',
                trackingWide && 'tracking-widest',
            )}>
                {value}
            </span>
            <Icon icon={copied ? 'Check' : 'Copy'} size="1x" className="ml-2 cursor-pointer shrink-0" />
        </div>
    </div>
}

export default CopyableValue;
